<template>
  <div class="flex flex-col gap-3 pt-3 border-t border-gray-200 dark:border-gray-700">
    <!-- Deal/No Deal: open -> show Deal!/No Deal buttons -->
    <template v-if="isDealNoDealType(action) && action.status === 'open'">
      <div class="flex gap-3">
        <button
          @click="$emit('deal', action)"
          :disabled="updating"
          class="flex-1 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-colors"
        >
          <CheckIcon class="h-4 w-4" />Deal!
        </button>
        <button
          @click="$emit('no-deal', action)"
          :disabled="updating"
          class="flex-1 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-colors"
        >
          <XMarkIcon class="h-4 w-4" />No Deal
        </button>
      </div>
    </template>
    <!-- Deal/No Deal: in_progress (deal confirmed, awaiting PL) -->
    <template
      v-else-if="
        isDealNoDealType(action) &&
        action.status === 'in_progress' &&
        action.action_outcome === 'deal'
      "
    >
      <div
        class="px-3 py-2 rounded-lg bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 text-sm font-medium text-center"
      >
        Deal bevestigd door {{ action.completed_by_name || 'commerciant' }}
      </div>
      <button
        @click="$emit('confirm-create-project', action)"
        :disabled="updating"
        class="w-full py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-colors"
      >
        <CheckIcon class="h-4 w-4" />
        {{ updating ? 'Verwerken...' : 'Bevestig beschikbaarheid' }}
      </button>
      <button
        @click="$emit('pl-no-match', action)"
        :disabled="updating"
        class="w-full py-2 text-sm font-medium text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/40 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-colors"
      >
        <XMarkIcon class="h-4 w-4" />
        Geen match
      </button>
    </template>
    <!-- Other action types: standard complete button -->
    <button
      v-else-if="action.status !== 'completed' && action.status !== 'cancelled'"
      @click="$emit('complete', action)"
      :disabled="updating"
      class="w-full py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-colors"
    >
      {{ updating ? 'Verwerken...' : 'Afgerond' }}
    </button>
    <a
      :href="`https://frisseblikken.simplicate.nl/sales/${action.prospect_simplicate_id}`"
      target="_blank"
      rel="noopener noreferrer"
      class="w-full py-2 text-sm font-medium text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center justify-center gap-2 transition-colors"
    >
      <ArrowTopRightOnSquareIcon class="h-4 w-4" />
      Bekijk in Simplicate
    </a>
    <button
      v-if="isAdmin"
      @click="$emit('delete', action)"
      :disabled="updating"
      class="w-full py-2 text-sm font-medium text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/40 disabled:opacity-50 flex items-center justify-center gap-2 transition-colors"
    >
      <TrashIcon class="h-4 w-4" />
      Verwijderen
    </button>
  </div>
</template>

<script setup>
import {
  CheckIcon,
  XMarkIcon,
  ArrowTopRightOnSquareIcon,
  TrashIcon
} from '@heroicons/vue/24/outline'
import { isDealNoDealType } from '@/constants/actions'

defineProps({
  action: { type: Object, required: true },
  updating: { type: Boolean, default: false },
  isAdmin: { type: Boolean, default: false }
})

defineEmits(['deal', 'no-deal', 'confirm-create-project', 'pl-no-match', 'complete', 'delete'])
</script>
